// import { MemberActionType } from '../../actions/member/memberTypes';
import { AttributeVoActionType } from '@/reducers/V2/V2Actions/AttributeVo/AttributeVoTypes';

const initialState: any = {
  // 第一層屬性 資料
  quantity: 1,
  itemVoInfo: {
    // 目前所選擇的 品項 基本資訊
    categoryId: 0,
    itemId: 0,
    attributeId: 0,
    attributeIds: [],
    title: '',
    limitQuantity: 0,
    imageUrl: '',
    sku: null,
    description: '',
    itemed: false,
    enable: false,
    displayOverrides: [],
    subDisplayOverrides: [],
    tags: [],
  },
  itemComment: '', // 品項備註
  displayAttributes: [], // 品項 第一層 底下的屬性
  selectedAttributes: [], // 品項 第一層 底下 選擇的屬性
  selectedOrderItems: [], // 品項 第一層 底下 選擇的 第二層屬性
  minSelectAlerts: [], // 檢查是否必選

  // 第二層屬性 資料
  secondItemVoInfo: {
    categoryId: 0,
    itemId: 0,
    attributeId: 0,
    attributeIds: [],
    title: '',
    limitQuantity: 0,
    sku: null,
    itemed: false,
    enable: false,
    displayOverrides: [],
    subDisplayOverrides: [],
  },
  displaySecondAttributes: [],
  selectedSecondAttributes: [],

  // 購物車 開啟屬性時多存取 voUuids
  cartAttributeVoUuids: [],
};

const AttributeVoReducer: (state: any, action: any) => any = (
  state = initialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case AttributeVoActionType.SET_ATTRIBUTE_VO_QUANTITY:
      return {
        ...state,
        quantity: payload,
      };
    case AttributeVoActionType.SET_ATTRIBUTE_VO_ITEMVO:
      return {
        ...state,
        itemVoInfo: payload,
      };
    case AttributeVoActionType.SET_ATTRIBUTE_VO_DISPLAY_ATTRIBUTES:
      return {
        ...state,
        displayAttributes: payload,
      };
    case AttributeVoActionType.SET_ATTRIBUTE_VO_ITEM_COMMENT:
      return {
        ...state,
        itemComment: payload,
      };
    case AttributeVoActionType.SET_ATTRIBUTE_VO_SECOND_ITEMVOINFO:
      return {
        ...state,
        secondItemVoInfo: payload,
      };
    case AttributeVoActionType.SET_ATTRIBUTE_VO_DISPLAY_SECOND_ATTRIBUTES:
      return {
        ...state,
        displaySecondAttributes: payload,
      };
    case AttributeVoActionType.SET_ATTRIBUTE_VO_SELECTED_ATTRIBUTES:
      return {
        ...state,
        selectedAttributes: payload,
      };
    case AttributeVoActionType.SET_ATTRIBUTE_VO_SELECTED_ORDERITEMS:
      return {
        ...state,
        selectedOrderItems: payload,
      };

    case AttributeVoActionType.SET_ATTRIBUTE_VO_SELECTED_SECOND_ATTRIBUTE:
      return {
        ...state,
        selectedSecondAttributes: payload,
      };
    case AttributeVoActionType.SET_ATTRIBUTE_VO_MIN_SELECTION_ALERTS:
      return {
        ...state,
        minSelectAlerts: payload,
      };
    case AttributeVoActionType.SET_ATTRIBUTE_VO_CART_ITEM_VOUUIDS:
      return {
        ...state,
        cartAttributeVoUuids: payload,
      };
    case AttributeVoActionType.SET_ATTRIBUTE_VO_RESET:
      return initialState;
    default:
      return state;
  }
};

export default AttributeVoReducer;
